/**
 * Sort options for the task board
 */
export var TaskBoardSortField;
(function (TaskBoardSortField) {
    TaskBoardSortField["CREATED_DATE"] = "createdAt";
    TaskBoardSortField["DUE_DATE"] = "dueDate";
    TaskBoardSortField["NOTE"] = "note";
})(TaskBoardSortField || (TaskBoardSortField = {}));
/**
 * Sort direction
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));
//# sourceMappingURL=types.js.map